import { ProductStore } from './types';
export class State {
  public searchBy: string;
  public assignedOnly: boolean;
  public assignedOnlyQuery: boolean;
  public product: ProductStore;
  constructor() {
    this.product = new ProductStore();
    this.assignedOnly = true;
    this.assignedOnlyQuery = true;
  }
  public resetProductData() {
    this.assignedOnly = true;
    this.assignedOnlyQuery = true;
    this.product = new ProductStore();
  }
}

const state = new State();

export default state;
